import React, { useState, useEffect } from "react";
import { TextareaInput, Message, BULMA } from "@graffer-inc/graffer-ui";
import { Link } from "react-router-dom";
import Http from "../../../http";
import Transition from "../../../utils/transition";
import ENTRY_STATUS from "../../../constants/entry-status";
import { connect } from "react-redux";
import PreSettingDone from '../../templates/pre-setting-done';

const Main = ({ match, loginAccount }) => {
  const { entryId } = match.params;
  const [userVoice, setUserVoice] = useState("");
  const [isNotified, setIsNotified] = useState(false);
  const fetchEntry = async () => Http.fetchEntry(
    entryId,
    res => {
      if (res.data.entry.status !== ENTRY_STATUS.CODE.DOWNLOADED) {
        Transition.goTo(`/entries/${entryId}`)
      }
    },
    () => Transition.goTo(`/entries/${entryId}`)
  );

  useEffect(() => {
    fetchEntry();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const notifyUserVoice = async () => {
    setIsNotified(true);
    const body = { text: userVoice };
    await Http.notifyUserVoice(entryId, body);
  };

  return (
    <PreSettingDone>
      <div className="container">
        <div className="spacer is-hidden-mobile" />
        <div className="columns is-centered">
          <div className="column is-8">
            <p
              className="is-size-3 is-size-4-mobile has-text-centered has-text-weight-bold"
              style={{ padding: "0 0 10px 0" }}
            >
              <span className="is-highlight">ご利用ありがとうございました。</span>
            </p>
            <Message color={BULMA.COLOR.INFO}>
              <p>電子証明書はダウンロードしたその日からご利用いただけます。</p>
              {/* eslint-disable-next-line */}
              <p>電子証明書の再ダウンロードをご希望の場合、<a onClick={() => Transition.newTab('https://form.run/@graffer-el-cert')}>こちら</a>からお問い合わせをお願いします。</p>
              <p>
                領収書は
                <Link to={`/entries/${entryId}/invoice`}>
                  こちら
                </Link>
                からダウンロードいただけます。
              </p>
            </Message>
            <p className="has-text-weight-bold is-size-5">
              サービスをご利用いただいた感想を聞かせてください。
            </p>
            <div
              className="is-size-7 has-text-grey"
              style={{ padding: "0 0 10px 0" }}
            >
              <p>
                どんな些細なことでも構いません。ご感想以外にもご要望や今後、ご期待いただけることがあれば、ぜひ率直なお話をお聞かせください。今後のサービス向上のために役立ててまいります。
              </p>
            </div>
            {isNotified ? (
              <>
                <p>
                  <span className="is-highlight">
                    貴重なご意見ありがとうございます。
                  </span>
                  <br />
                  <span>
                    お客様により良い体験をご提供できるよう、サービス改善に努めてまいります。
                  </span>
                  <br />
                  <span>
                    引き続き、「Graffer
                    電子証明書取得サポート」をよろしくお願いします。
                  </span>
                </p>
                <div
                  style={{ padding: "30px 0" }}
                  className="columns is-centered"
                >
                  <div className="column is-11">
                    <Link className="button is-rounded is-fullwidth" to="/home">
                      ホームに戻る
                    </Link>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="columns is-centered">
                  <div className="column is-11">
                    <TextareaInput
                      value={userVoice}
                      placeholder="ご感想、ご要望など"
                      onChange={setUserVoice}
                      validate={() => true}
                    />
                    <div style={{ padding: "15px 0" }}>
                      <button
                        className="button is-info is-rounded is-fullwidth"
                        onClick={notifyUserVoice}
                        disabled={userVoice.length === 0}
                      >
                        ご意見・ご要望を送る
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
            <p className="has-text-weight-bold is-size-5">
              早速、印鑑証明書を注文してみませんか？
            </p>
            <div
              className="is-size-7 has-text-grey"
              style={{ padding: "0 0 10px 0" }}
            >
              <p>
                電子証明書を取得されたので、後は印鑑カード番号の登録などの数分で終わる事前設定が完了すれば、「Graffer法人証明書請求」からいつでも1クリックでご注文いただけるようになります。
              </p>
              <div
                style={{ padding: "30px 0" }}
                className="columns is-centered"
              >
                <div className="column is-11">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="button is-rounded is-fullwidth"
                    href={`https://registry-certs.graffer.jp/entries/add/${loginAccount.company.corporateId}/corporateId?utm_source=e-cert&utm_medium=complete-page-link-to-corporate-certs`}>
                    自社の証明書を注文する
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PreSettingDone>
  );
};

export default connect(
  store => ({
    loginAccount: store.user.loginAccount,
  }),
)(Main);